var sdUtils = {
  customFixedNavbar: function() {
      //Make header fixed on scroll    
      function setStickyAttribute() {
        $('.header-fixed--fixed_v2').removeClass('sticky');
        $('.mobile_nav-fixed--fixed_v2').removeClass('sticky');
        document.body.style.paddingTop = "0"
        
        if ($(window).width() > 798 && window.pageYOffset > 1) {
            $('.header-fixed--fixed_v2').addClass('sticky');
          } else if ($(window).width() < 799) {
            $('.mobile_nav-fixed--fixed_v2').addClass('sticky');
            document.body.style.paddingTop = "73px"
          //made sticky class permanent on mobile to combat jumpy behavior
          }
        }
        window.onscroll = function() {setStickyAttribute()};
  },
  
  handleize: function (str) {
    return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
  },
  cartInit: function () {
    if ($('body').hasClass('cart')) {
      // Trigger cart pop up if message present
      $.fancybox.open($('#cartpage-popup'), {
        baseClass: 'newsletter__lightbox',
        hash: false,
        infobar : false,
        toolbar: false,
        loop: true,
        smallBtn : true,
        mobile: {
          preventCaptionOverlap: false,
          toolbar: true,
          buttons: [
            "close"
          ]
        }
      });

    }
  },

  checkGiftCardOnlyCart: function () {
    var cartItems = JSON.parse(document.getElementById('cart-items').textContent);
    var giftCardsInCart = cartItems.filter(function(cartItem) {
      return cartItem.handle.includes('gift-card')
    });

    return giftCardsInCart.length == cartItems.length;
  }
}

if($(window).width() < 799) document.body.style.paddingTop = "73px"